export const environment = {
  production: true,
  basePortalUrl: 'https://cms.wineark.com.au',
  authUrl: 'https://identity.nationalstorage.com.au',
  userManagementUrl: 'https://api.wineark.com.au/usermanagement',
  referenceDataUrl: 'https://api.wineark.com.au/referencedata',
  facilityManagementUrl: 'https://api.wineark.com.au/facilitymanagement',
  storageManagementUrl: 'https://api.wineark.com.au/storagemanagement',
  billingUrl: 'https://api.wineark.com.au/billing',
  paymentsUrl: 'https://api.wineark.com.au/payments',
  marketplaceUrl: 'https://api.wineark.com.au/marketplace',
  logisticsUrl: 'https://api.wineark.com.au/logistics',
  notificationsUrl: 'https://api.wineark.com.au/notifications',
  marketplaceClientUrl: 'https://marketplace.wineark.com.au',
  inactivityMonitorIdle: '60',
  inactivityMonitorTimeout: '60',
  showBottleDetailsQRCode: 'false',
  isAccountClosingFeatureEnabled: true,
  sentryDsn: "https://1b1546fe4dbfd68ffd70b487cec57280@o4504760973983744.ingest.us.sentry.io/4508243818577920",
  sentryEnvironmentName: "Production",
  apiBaseUrl: '#{Api_BaseUrl}'
};
